import { CopilotPanelContentBase, CopilotPanelContext } from 'models/copilot/copilotBridge';
import { CopilotConversation } from 'models/copilot/copilotConversation';
import { CopilotConversationDTO } from 'models/dto/copilot/copilotConversationDTO';

export class TenantProcessStateControlEvidenceAudit {
  controlId: number;

  selectedRecommendationIds: number[];

  createdTaskIds: number[];

  conversation: CopilotConversation;

  constructor() {
    this.controlId = 0;
    this.selectedRecommendationIds = [];
    this.createdTaskIds = [];
    this.conversation = new CopilotConversation();
  }
}

export class TenantProcessStateControlEvidenceAuditDTO {
  controlId: number;

  selectedRecommendationIds: number[];

  createdTaskIds: number[];

  conversation: CopilotConversationDTO;

  // Audit period (ISO datetime). Undefined lets the backend default to the current audit year.
  periodStart?: string;

  periodEnd?: string;

  constructor() {
    this.controlId = 0;
    this.selectedRecommendationIds = [];
    this.createdTaskIds = [];
    this.conversation = new CopilotConversationDTO();
  }
}

export class CopilotControlAuditContent extends CopilotPanelContentBase {
  public readonly context: CopilotPanelContext;

  controlId: number;

  constructor(controlId: number, context = CopilotPanelContext.ControlEvidenceAudit) {
    super();
    this.context = context;
    this.controlId = controlId;
  }
}

export class CopilotControlEvidenceAuditContent extends CopilotControlAuditContent {
  constructor(controlId: number) {
    super(controlId, CopilotPanelContext.ControlEvidenceAudit);
  }
}
